var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"component letter-preview"},[_c('div',{staticStyle:{"text-align":"left"},attrs:{"id":"LetterPage"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.previewContent)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }